import '../../../styles/supervise.scss';
import './index.scss';
import React, { useState } from 'react';

import { SearchBar } from './searchBar';
import { ClassList } from './classList';

function OnlineCourseTour() {
  /*
   * 用于搜索查询
   * */
  let refClassroom = React.createRef();
  const [classname, setClassName] = useState('');
  function getClassroom() {
    sessionStorage.setItem('onlineCourseTour_classname', refClassroom.current.value);
    setClassName(refClassroom.current.value);
  }

  return (
    <div className="online-course-tour">
      <SearchBar ref_classroom={refClassroom} getClassroom={getClassroom} />
      <ClassList classname={classname} />
    </div>
  );
}
export default OnlineCourseTour;
